<template>
	<div class="wrapper">
		<div class="d-block">
			<div class="d-top">
				订单号：
				<span class="theme">{{ order_id }}</span>
				订单金额：
				<span class="theme">￥{{ orderInfo.order_amount }}</span>
				订单状态：
				<span>
					<b>{{ orderText(orderInfo.text_status) }}</b>
				</span>
				<div class="state-handle">
					<template v-if="orderInfo.text_status == 1">
						<span class="btn" @click="cancelOrder">取消订单</span>
						<span class="btn">
							<router-link :to="{ name: 'cashier', params: { order_id: order_id } }">立即支付</router-link>
						</span>
					</template>

					<template v-else-if="orderInfo.text_status == 3">

						<span class="btn" @click="tackDelivery(orderInfo.order_id)">确认收货</span>
					</template>
					<template v-else-if="orderInfo.text_status == 4">

						<span class="btn" v-if="orderInfo.bill_aftersales_id == false&&orderInfo.wuliao_path" @click="customerService(orderInfo.order_id)">申请回收</span>
						<span class="btn" v-if="orderInfo.bill_aftersales_id && orderInfo.bill_aftersales_id != false" @click="showCustomerService(orderInfo.bill_aftersales_id)">
							查看回收
						</span>

					</template>
					<template v-else-if="orderInfo.text_status == 5">
						<span class="btn" v-if="orderInfo.bill_aftersales_id == false&&orderInfo.wuliao_path" @click="customerService(orderInfo.order_id)">申请回收</span>
						<span class="btn" v-if="orderInfo.bill_aftersales_id && orderInfo.bill_aftersales_id != false" @click="showCustomerService(orderInfo.bill_aftersales_id)">
							查看回收
						</span>
					</template>
				</div>
			</div>
			<div class="order-progress" v-show="orderInfo.text_status != 7">
				<ul class="progress-list">
					<li class="step" :class="orderInfo.text_status >= 1 ? 'past' : ''">
						<div>
							<span class="text">提交订单</span>
						</div>
					</li>
					<li class="step" :class="orderInfo.text_status > 1 ? 'past' : ''">
						<div>
							<span class="text">付款成功</span>
						</div>
					</li>
					<li class="step" :class="orderInfo.text_status > 2 ? 'past' : ''">
						<div>
							<span class="text">发货</span>
						</div>
					</li>
					<li class="step" :class="orderInfo.text_status > 3 ? 'past' : ''">
						<div>
							<span class="text">确认收货</span>
						</div>
					</li>
					<li class="step" :class="orderInfo.text_status > 4 ? 'past' : ''">
						<div>
							<span class="text">交易成功</span>
						</div>
					</li>
				</ul>
			</div>
			<div class="wl" v-if="isDelivery">
				<span class="title">物流：</span>
				<span class="info" v-for="(item, index) in orderInfo.delivery" :key="index">
					<span class="look-detail" @click="getLogistics">{{ item.logi_name||'' }}，物流单号：{{ item.logi_no||'' }}</span>
				</span>
			</div>
		</div>
		<div class="d-block">
			<div v-if="!orderInfo.store">
				<div class="d-title">收货信息</div>
				<table class="info-table">
					<tbody>
						<tr>
							<th>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</th>
							<td>{{ orderInfo.ship_name }}</td>
						</tr>
						<tr>
							<th>联系电话：</th>
							<td>{{ orderInfo.ship_mobile }}</td>
						</tr>
						<tr>
							<th>身&nbsp;&nbsp;份&nbsp;&nbsp;证：</th>
							<td>{{ orderInfo.idcard_no }}</td>
						</tr>
						<tr>
							<th>收货地址：</th>
							<td>{{ orderInfo.ship_area_name }}{{ orderInfo.ship_address }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="d-title">自提信息</div>
				<table class="info-table" v-if="orderInfo.store">
				<tbody> 
					<tr>
						<th>门&nbsp;店&nbsp;&nbsp;名&nbsp;称：</th>
						<td>{{orderInfo.store.store_name || ''}}</td>
					</tr>
					<tr>
						<th>门&nbsp;店&nbsp;&nbsp;电&nbsp;话：</th>
						<td>{{orderInfo.store.mobile || ''}}</td>
					</tr>
					<tr>
						<th>门&nbsp;店&nbsp;&nbsp;地&nbsp;址：</th>
						<td>{{orderInfo.store.all_address || ''}}</td>
					</tr>
					<tr>
						<th>提货人姓名：</th>
						<td>{{ orderInfo.ship_name || ''}}</td>
					</tr>
					<tr>
						<th>提货人电话：</th>
						<td>{{ orderInfo.ship_mobile || ''}}</td>
					</tr>
					<tr v-if="lading.status">
						<th>提&nbsp;&nbsp;&nbsp;货&nbsp;&nbsp;&nbsp;码：</th>
						<td style="color:#FF7159;">{{ lading.code|| '' }}</td>
					</tr>
				</tbody>
			</table>
			</div>
			
		</div>
		<div class="d-block" v-if="!orderInfo.store">
			<div class="d-title">配送方式</div>
			<div class="info-table">
				<div class="info-div">
					配送方式：
					<span>{{ orderInfo.logistics_name }}</span>
				</div>
				<div class="info-div">
					运费：
					<span>￥{{ orderInfo.cost_freight }}</span>
				</div>
			</div>
		</div>
		<div class="d-block">
			<div class="d-title">给卖家的留言</div>
			<div class="info-table">
				<div class="info-div">
					<span>{{ orderInfo.memo }}</span>
				</div>
			</div>
		</div>
		<div class="d-block" v-if="orderInfo.pay_status > 1">
			<div class="d-title">支付方式</div>
			<div class="info-table">
				<div class="info-div"> 支付方式：
					<span>{{ orderInfo.payment_name }}</span>
				</div>
				<div class="info-div"> 支付时间：
					<span>{{ timeResolve(orderInfo.payment_time) }}</span>
				</div>
			</div>
		</div>
		<!-- tax_type 1： 不开发票，2:个人事业单位发票, 3:企业发票 -->
		<div class="d-block" v-if="orderInfo.tax_type != 1">
			<div class="d-title">发票信息</div>
			<div class="info-table">
				<div class="info-div"> 发票抬头:
					<span>{{ orderInfo.tax_title }}</span>
				</div>
				<div class="info-div" v-if="orderInfo.tax_type == 3"> 发票税号:
					<span>{{ orderInfo.tax_code }}</span>
				</div>
			</div>
		</div>
		<div class="d-block">
			<div class="d-title">商品和结算清单</div>
			<div class="d-order">
				<div class="head order-box">
					<div class="order-info">商品</div>
					<div class="order-price">销售价</div>
					<div class="order-num">数量</div>
					<div class="order-shape">优惠金额</div>
					<div class="order-grade">积分</div>
					<div class="order-total-price">小计</div>
				</div>
			</div>
			<div class="d-order">
				<div class="order-box order-item" v-for="(item, index) in orderInfo.items" :key="index">
					<div class="order-info">
						<img :src="item.image_url" :alt="item.name" class="order-img" />
						<span class="order-name">{{ item.name }}</span>
					</div>
					<div class="order-price">￥{{ item.price }}</div>
					<div class="order-num">
						<i class="icon iconfont iconchenghao">{{ item.nums }}</i>
					</div>
					<div class="order-shape">￥0.00</div>
					<div class="order-grade">0</div>
					<div class="order-total-price">￥{{ item.amount }}</div>
				</div>
			</div>
			<div class="cart-discount">
				<div class="old">
					<span class="text">商品总额：</span>
					<span class="num">￥{{ orderInfo.goods_amount }}</span>
				</div>
				<div class="old">
					<span class="text">运费：</span>

					<span class="num">￥{{ orderInfo.cost_freight }}</span>
				</div>
				<div class="old" v-if="orderInfo.goods_pmt > 0">
					<span class="text">商品优惠：</span>

					<span class="num">-￥{{ orderInfo.goods_pmt }}</span>
				</div>
				<div class="old" v-if="orderInfo.point_money > 0">
					<span class="text">积分抵扣：</span>

					<span class="num">-￥{{ orderInfo.point_money }}</span>
				</div>
				<div class="old" v-if="orderInfo.order_pmt > 0">
					<span class="text">订单优惠：</span>

					<span class="num">-￥{{ orderInfo.order_pmt }}</span>
				</div>
				<div class="old" v-if="orderInfo.coupon_pmt > 0">
					<span class="text">其他优惠：</span>

					<span class="num">-￥{{ orderInfo.coupon_pmt }}</span>
				</div>
				<div class="discount">
					<span class="text">订单总价：</span>

					<span class="total num">￥{{ orderInfo.order_amount }}</span>
				</div>
			</div>
		</div>
		<el-dialog title="物流信息" :visible.sync="centerDialogVisible" width="50%">
			<div class="wl-container">
				<el-timeline>
					<el-timeline-item v-for="(activity, index) in activities.data" :key="index" :color="activity.color" :timestamp="returnTime(activity.time)">
						{{ activity.context }}
					</el-timeline-item>
				</el-timeline>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { timeToDate } from '@/utils'
export default {
  name: 'OrderDetail',
  components: {},
  props: {},
  data() {
    return {
      centerDialogVisible: false,
      order_id: '',
      activities: [], //物流详情
			orderInfo: {},
			lading: {
				status: false,
				code: ''
			}, //提货信息
    }
  },
  watch: {},
  computed: {
    //是否发货
    isDelivery() {
      if (
        this.orderInfo.ship_status > 2 &&
        this.orderInfo.hasOwnProperty('delivery') &&
        this.orderInfo.delivery.length
      ) {
        return true
      } else {
        return false
      }
    },
    timeResolve() {
      return time => {
        return timeToDate(time)
      }
    },
    orderText() {
      return status => {
        switch (status) {
          case 1:
            return '待付款'
          // break;
          case 2:
            return '待发货'
          // break;
          case 3:
            return '待收货'
          // break;
          case 4:
            return '待评价'
          // break;
          case 6:
            return '交易完成'
          // break;
          case 7:
            return '交易取消'
          // break;
          default:
            return '交易成功'
          // break;
        }
      }
    },
    returnTime() {
      return val => {
        let date = val.split(' ')
        return (
          date[0].substring(5, date[0].length) + ' ' + date[1].substring(0, 5)
        )
      }
    },
  },
  methods: {
    //申请售后
    customerService(id) {
      this.$router.push({ name: 'currefundApply', params: { order_id: id } })
    },
    //查看售后
    showCustomerService(id) {
      this.$router.push({
        name: 'refundDetail',
        params: { aftersales_id: id },
      })
    },
    //确认收货
    tackDelivery(order_id) {
      this.$confirm('确定已收到宝贝?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let data = {
          order_id: order_id,
        }
        this.$api.confirmOrder(data).then(res => {
          if (res.status) {
            this.$msg('确认收货成功!')
            this.getOrderDetail()
          }
        })
      })
    },
    getLogistics() {
      let address1 = this.orderInfo.ship_area_name
        ? this.orderInfo.ship_area_name
        : ''
      let address2 = this.orderInfo.ship_address
        ? this.orderInfo.ship_address
        : ''
      let address = address1 + address2
      console.log(address)
      let code = this.orderInfo.delivery[0].logi_code
      let no = this.orderInfo.delivery[0].logi_no
      this.expressInfo(code, no)
      this.centerDialogVisible = true
    },
    //物流详情
    expressInfo(code, no) {
      let data = {
        code,
        no,
      }
      this.$api.logistics(data).then(res => {
        if (res.status) {
          this.activities = res.data.info
          this.activities.data[0].color = '#FF7159'
        }
      })
    },
    getOrderDetail() {
      let data = {
        order_id: this.order_id,
      }
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          let data = res.data
					console.dir(res.data)
					if(data.ladingItem[0]){
						this.lading = {
							status: true,
							code: data.ladingItem[0].id
						}
					}
          // this.orderInfo = res.data;
          // 订单状态文字转化
          switch (data.status) {
            case 1:
              if (data.pay_status === 1) {
                data.text_status = 1
              } else if (data.pay_status >= 2 && data.ship_status === 1) {
                data.text_status = 2
              } else if (data.pay_status >= 2 && data.ship_status === 2) {
                data.text_status = 2
              } else if (
                data.pay_status >= 2 &&
                data.ship_status >= 3 &&
                data.confirm === 1
              ) {
                data.text_status = 3
              } else if (
                data.pay_status >= 2 &&
                data.ship_status >= 3 &&
                data.confirm >= 2 &&
                data.is_comment === 1
              ) {
                data.text_status = 4
              } else if (
                data.pay_status >= 2 &&
                data.ship_status >= 3 &&
                data.confirm >= 2 &&
                data.is_comment >= 2
              ) {
                data.text_status = 5
              }
              break
            case 2:
              data.text_status = 6
              break
            case 3:
              data.text_status = 7
              break
          }
          this.orderInfo = data
        }
      })
    },
    cancelOrder() {
      let data = {
        order_ids: this.order_id,
      }
      this.$api.cancelOrder(data).then(res => {
        if (res.status) {
          this.$msg(res.msg)
          this.getOrderDetail()
        }
      })
    },
  },
  created() {},
  mounted() {
    let orderId = this.$route.params.order_id
    this.order_id = orderId
    this.getOrderDetail()
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.cart-discount {
  padding: 15px 30px;
  text-align: right;
  .old,
  .discount {
    line-height: 24px;
    span {
      display: inline-block;
      &.text {
        width: 100px;
      }
      &.num {
        min-width: 100px;
        color: $theme-color;
      }
      &.total {
        margin-top: 10px;
        font-size: 24px;
      }
    }
  }
}
.wrapper {
  .wl-container {
    padding: 30px;
  }
  .d-block {
    padding-bottom: 20px;
    position: relative;
    &:not(:last-of-type) {
      border-bottom: 1px solid $border;
      margin-bottom: 20px;
    }
    .d-top {
      position: relative;
      height: 30px;
      line-height: 30px;
    }
    span.theme {
      color: $theme-color;
      margin-right: 28px;
    }
    b {
      font-weight: bold;
    }
    .d-title {
      font-size: 18px;
      margin-bottom: 15px;
    }
    .info-table {
      color: #757575;
      tr {
        height: 30px;
        line-height: 30px;
      }
      .info-div {
        // height: 30px;
        line-height: 30px;
      }
    }
    .state-handle {
      position: absolute;
      right: 0;
      top: 0;
      .btn {
        height: 30px;
        line-height: 30px;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        margin-left: 30px;
        color: $theme-color;
        border: 1px solid $theme-color;
        width: 100px;
        transition: all 0.2s;
        a {
          display: block;
        }
        &:hover {
          background: $theme-color;
          color: #fff;
        }
      }
    }
    .d-order {
      .order-box {
        display: flex;
        align-items: center;
        height: 100px;
        border-bottom: 1px solid $border;
        &.head {
          height: 40px;
          line-height: 40px;
          .order-info {
            text-indent: 30px;
          }
        }
        .order-info {
          width: 450px;
          display: inline-flex;
          align-items: center;
          .order-img {
            display: inline-block;
            width: 80px;
            height: 80px;
            border: 1px solid $border;
            margin-top: 5px;
            margin-right: 10px;
            object-fit: cover;
          }
          .order-name {
            display: inline-block;
            line-height: 20px;
          }
        }
        .order-price {
          width: 100px;
          text-align: center;
        }
        .order-num {
          width: 100px;
          text-align: center;
        }
        .order-shape {
          width: 100px;
          text-align: center;
        }
        .order-grade {
          width: 80px;
          text-align: center;
        }
        .order-total-price {
          flex: 1;
          color: $theme-color;
          text-align: center;
        }
      }
    }
  }
  .wl {
    position: relative;
    margin: 10px 0;
    .title {
      position: absolute;
      left: 0;
      top: 0;
      line-height: 1.4;
    }
    .info {
      margin-left: 60px;
      line-height: 1.4;
      .look-detail {
        color: $theme-color;
        cursor: pointer;
      }
    }
  }
  .order-progress {
    margin: 20px auto 30px;
    .progress-list {
      display: flex;
      height: 20px;
      line-height: 20px;
      padding: 0;
      margin: 0 auto;
      border-radius: 10px;
      font-size: 12px;
      text-align: center;
      color: #424242;
      .step {
        width: 180px;
        background-color: #eee;
        &:first-of-type {
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        }
        &:last-of-type {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
        }
        &.active {
          color: #fff;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          background-color: $theme-color;
        }
        &.past {
          color: #fff;
          background-color: $theme-color;
        }
      }
    }
  }
}
</style>
